'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Navbar = require('../../Navbar.js');
require('./NavbarProfile.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var NavbarProfile = function () {
    var _a = Navbar.useNavbarContext(), isAuthenticated = _a.isAuthenticated, loginAction = _a.loginAction;
    if (isAuthenticated || !loginAction) {
        return React__default['default'].createElement("div", { className: 'np-root' });
    }
    return (React__default['default'].createElement("div", { className: 'np-root' },
        React__default['default'].createElement("a", { title: "Login", href: "#login", onClick: function (e) {
                e.preventDefault();
                loginAction();
            } },
            React__default['default'].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" },
                React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20ZM24 14C24 16.2091 22.2091 18 20 18C17.7909 18 16 16.2091 16 14C16 11.7909 17.7909 10 20 10C22.2091 10 24 11.7909 24 14ZM19.9999 22C15.9648 22 12.4879 24.3899 10.9075 27.8314C13.1081 30.3841 16.3653 32 20 32C23.6346 32 26.8917 30.3841 29.0923 27.8316C27.5119 24.39 24.035 22 19.9999 22Z" })),
            React__default['default'].createElement("span", null, "Masuk"))));
};

exports.NavbarProfile = NavbarProfile;
//# sourceMappingURL=NavbarProfile.js.map
